import { usePathname, useSearchParams } from 'next/navigation'
import React, { useEffect } from 'react'

import { useAuthUser } from '@/modules/Auth'

import * as gtm from '../gtm'

export function usePageView() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { authUser } = useAuthUser()
  const ref = React.useRef<string | null>(null)

  useEffect(() => {
    if (!pathname) return

    // prevent duplications
    if (ref.current === pathname) return

    ref.current = pathname

    gtm.pageview(pathname, authUser, {
      programId: searchParams?.get('programId')
        ? Number(searchParams.get('programId'))
        : undefined,
      facilityId: searchParams?.get('facilityId')
        ? Number(searchParams.get('facilityId'))
        : undefined,
    })
  }, [pathname, searchParams, authUser])
}
